(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["Counter"] && !window.DesignMode) return;
  try {
    
var speed = 1000;

var START_DATE = new Date("Jan 01, 2020 00:00:00"); // put in the starting date here
var INTERVAL = 1; // in seconds
var INCREMENT = 11 // increase per tick
var START_VALUE = 11; // initial value when it's the start date
var count = 0;

var msInterval = INTERVAL * 1000;
var now = new Date();
count = parseInt((now - START_DATE)/msInterval) * INCREMENT + START_VALUE;

    go();
    setInterval(function () {
        go();
    }, speed);

function go() {
    $("#counter").html(count.toLocaleString());
    count += 11;
}


  } catch(e) { console.error(e); }
})();

})();
